// BookTime.tsx

import * as React from "react";
import { DateTimeSelection } from "../dateTimeSelection/DateTimeSelection";

export interface BookTimeProps {}

export const BookTime: React.FC<BookTimeProps> = () => {
  return <DateTimeSelection />;
};
